export default "__VITE_ASSET__CG0ZM4al__"